var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTyperight = function SvgTyperight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.795 11.5-2.793-2.793A.5.5 0 0 1 12.709 8l3.646 3.646a.5.5 0 0 1 0 .707L12.71 16a.5.5 0 1 1-.707-.707l2.793-2.793H7.502a.5.5 0 1 1 0-1h7.293Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.002 12c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-10-9a9 9 0 1 1 0 18 9 9 0 0 1 0-18Z",
    fill: "currentColor"
  })));
};
export { SvgTyperight as ReactComponent };
export default __webpack_public_path__ + "d3bbc6d6943cd35a59fcf8b0c7140705.svg";